exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ftv-magneto-pins--container {\n    margin: auto;\n    display: flex;\n    position: absolute;\n    width: 100%;\n    transform: translateY(calc(-100%));\n}\n\n.ftv-magneto-pins {\n    position: absolute;\n    bottom: 100%;\n    transform-origin: center bottom;\n    transform: translateX(-50%)\n}\n\n.ftv-magneto-pins:hover {\n    position: absolute;\n    transform-origin: center bottom;\n    transform: translateX(-50%) scale(1.5);\n    transition: scale 300ms;\n    bottom: 100%;\n}\n", ""]);

// exports
